













import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  CaseDashboard,
  CaseFilter,
  CaseRecord,
  CaseTasks,
  Tab,
} from "@/store/modules/types";
import moment from "moment";
import Pager from "@/components/case/TaskPager.vue";
import List from "@/components/case/TaskList.vue";
import { randomId } from "@/utils";

@Component({
  components: {
    Pager,
    List,
  },
  computed: {
    ...mapState("cases", ["tasks"]),
  },
})
export default class Tasks extends Vue {
  tasks!: CaseTasks;
  @Watch("tasks.filter", { deep: true })
  onFilterChanged() {
    this.getTasks();
  }
  async getTasks() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("cases/getTasks");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getTasksCSV() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("cases/getTasksCSV");
      const blob = new Blob([data], { type: "text/csv" });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      anchor.download = `WMPC_TASKS_${timestamp}.csv`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getTasksExcel() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const mime = "application/octet-stream";
      const data = await this.$store.dispatch("cases/getTasksExcel");
      const blob = new Blob([data], { type: mime });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      anchor.download = `WMPC_TASKS_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [mime, anchor.download, anchor.href].join(
        ":"
      );
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async editCase(item) {
    // GET CASE RECORD
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("cases/getRecord", item.caseId);
      data.record.patientInfo = {
        demographic: null,
        contacts: [],
        providers: [],
        gaps: [],
      };
      data.record.medicationNotes = [];
      data.record.comments = [];
      // CREATE TAB
      const id = randomId(6);
      const tab: Tab = {
        id,
        name: `Case ${item.caseId}`,
        component: "CaseEditor",
        props: {
          tabId: id,
          caseRecord: data.record,
        },
        showRemove: true,
      };
      // ADD CASE TAB
      this.$store.commit("cases/ADD_NEW_TAB", tab);
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    //
  }
  checkTasks() {
    this.tasks.pageRows.forEach((item) => {
      item.checked = true;
    });
  }
  uncheckTasks() {
    this.tasks.pageRows.forEach((item) => {
      item.checked = false;
    });
  }
  editPatient(id: number) {
    this.$emit("edit-patient", id);
  }
  get checkedRows() {
    return this.tasks.pageRows.filter((row) => {
      return row.checked;
    });
  }
  get rowsChecked(): Boolean {
    return this.checkedRows.length != 0;
  }
}
